import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import performRequest from '../Api/request';

const EmailConfirmation = () => {

let {email} = useParams()
    useEffect(()=>{

        console.log('email', email)
        
          
            try {
              const data = { 
                email, 
                consent_source: "permissino pass" 
              };
          
              const response =  performRequest("POST", "/news-letter/subscribe-email", data);

              if(response){
                alert("confirmed  successfully!");
              }
             
            } catch (error) {
              console.error("Subscription failed:", error);
              alert("Something went wrong. Please try again.");
            }
        
    })
  return (
       <div className='page-wrapper container-xxl'>

            
              <div className='mt-8 text-center display-6 fw-bold text-lime'>
                 Thanks for confirmation 
                 <br />

                  <button className='btn btn-outline-green mt-2'>Home</button>
              </div>
              
         
       </div>
  )
}

export default EmailConfirmation